module.exports = __webpack_public_path__ + "static/media/promo.95f18ab1.gif";